import { ref } from 'vue'
import { getProfile, updateProfile as updateProfileApi } from '~/javascript/api/profiles'

export function useProfileData() {
  // State
  const profile = ref({})
  const loadingProfile = ref(false)

  // Actions
  const fetchProfile = async() => {
    loadingProfile.value = true

    try {
      const response = await getProfile()
      profile.value = response.data
      return response.data
    } catch (error) {
      console.error('Error fetching profile:', error)
      throw error
    } finally {
      loadingProfile.value = false
    }
  }

  const updateProfile = async(data) => {
    loadingProfile.value = true

    try {
      const response = await updateProfileApi(data)
      profile.value = response.data
      return response.data
    } catch (error) {
      console.error('Error updating profile:', error)
      throw error
    } finally {
      loadingProfile.value = false
    }
  }

  return {
    // State
    profile,
    loadingProfile,

    // Actions
    fetchProfile,
    updateProfile
  }
}
